import axios from 'axios'
import { Message } from 'element-ui'
import { parseTime } from '.'
import { getToken } from './auth'
import router from '@/router'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 60000 // 请求时长
})

service.interceptors.request.use(
  config => {
    config.headers['ACCESSTOKEN'] = getToken()
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const { data: res, status } = response
    if (res.code === 200) {
      return res
    } else {
      if (res.code === 432) {
        Message({
          message: '登录失效，请重新登录',
          type: 'error',
          duration: 2000
        })
        if (
          window.location.pathname !='/2c/appDiscountCoupon'
          || window.location.pathname !='/2c/newWXLogin'
          || window.location.pathname !='/2c/client2/newIndex2'
          || window.location.pathname !='/2c/appDiscountCoupon'
          || window.location.pathname !='/2c/appAppraise'
          || window.location.pathname !='/2c/sampleImage'
          || window.location.pathname !='/2c/sampleImages'
          || window.location.pathname !='/2c/si'
          || window.location.pathname !='/2c/Zip'
          || window.location.pathname !='/2c/videoViewing'
          || window.location.pathname !='/2c/applySubAccount'
        )
        {
          localStorage.clear()
          sessionStorage.setItem('returnTo', window.location.href);
          router.push('wxLogin')
        }

      } else if (res.code === 4002) {
        return res
      } else if (res.code === 500 || res.code === 502) {
        Message({
          message: res.msg || '请求出错了，请联系管理员!',
          type: 'error',
          duration: 2000
        })
      }
      const { url, data, method, params } = response.config
      console.warn(
        `
        请求地址: ${url}
        请求方法: ${method}
        params参数: ${JSON.stringify(params)}
        body参数: ${data}
        状态码: ${status}
        错误信息: ${res.msg}
        发起时间: ${parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}')}
        `
      )
      return res
    }
  },
  err => {
    const { url, method, data, params } = err.config
    const { status, statusText } = err.response
    console.warn(
      `
      请求地址: ${url}
      请求方法: ${method}
      params参数: ${JSON.stringify(params)}
      body参数: ${data}
      发起时间: ${parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}')}
      状态码: ${status}
      返回结果: ${statusText}
      `
    )
    Message({
      message: `请求出错，错误代码: ${status}`,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(err)
  }
)

/**
 * POST
 * @param {String} url
 * @param {Object} data
 * @param {Object} params
 * @param {Object} config
 * @returns service
 */
export const post = (url, data = {}, params = {}, config = {}) =>
  service({
    method: 'POST',
    url,
    data,
    params: { ...params },
    ...config
  })

/**
 * GET
 * @param {String} url
 * @param {Object} params
 * @param {Object} config
 * @returns service
 */
export const get = (url, params = {}, config = {}) =>
  service({
    method: 'GET',
    url,
    params: { ...params },
    ...config
  })

/**
 * DELETE
 * @param {String} url
 * @param {Object} params
 * @param {Object} config
 * @returns service
 */
export const del = (url, data = {}, params = {}, config = {}) =>
  service({
    method: 'DELETE',
    url,
    data,
    params: { ...params },
    ...config
  })

/**
 * PUT
 * @param {String} url
 * @param {Object} data
 * @param {Object} params
 * @param {Object} config
 * @returns service
 */
export const put = (url, data = {}, params = {}, config = {}) =>
  service({
    method: 'PUT',
    url,
    data: { ...data },
    params: { ...params },
    ...config
  })

/**
 * PATCH
 * @param {String} url
 * @param {Object} data
 * @param {Object} params
 * @param {Object} config
 * @returns service
 */
export const patch = (url, data = {}, params = {}, config = {}) =>
  service({
    method: 'PATCH',
    url,
    data: { ...data },
    params: { ...params },
    ...config
  })

export default service
export const request = config => service({ ...config })



// WEBPACK FOOTER //
// ./src/utils/request.js